// <auto-generated />
// assembly: SecureTokenService.Generator.TypeScript, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
// generator: SecureTokenService.Generator.TypeScript.ModelsSourceGenerator

export interface IRegisterCommand {
    nationality: string,
    cedula: string,
    passport: string,
    givenName: string,
    familyName: string,
    birthDate: string,
    email: string,
    profileEmail: string,
    address: string,
    phonePrefix: string,
    phoneNumber: string,
    password: string,
    repeatPassword: string,
    pin: string,
    repeatPin: string,
    profilePhoto: string,
    cedulaPhoto: string,
    passportPhoto: string,
    keyValid: string,
}

export class RegisterCommand implements IRegisterCommand {
    nationality: string;
    cedula: string;
    passport: string;
    givenName: string;
    familyName: string;
    birthDate: string;
    email: string;
    profileEmail: string;
    address: string;
    phonePrefix: string;
    phoneNumber: string;
    password: string;
    repeatPassword: string;
    pin: string;
    repeatPin: string;
    profilePhoto: string;
    cedulaPhoto: string;
    passportPhoto: string;
    keyValid: string;
    
    constructor(nationality: string, cedula: string, passport: string, givenName: string, familyName: string, birthDate: string, email: string, profileEmail: string, address: string, phonePrefix: string, phoneNumber: string, password: string, repeatPassword: string, pin: string, repeatPin: string, profilePhoto: string, cedulaPhoto: string, passportPhoto: string, keyValid: string) {
        this.nationality = nationality;
        this.cedula = cedula;
        this.passport = passport;
        this.givenName = givenName;
        this.familyName = familyName;
        this.birthDate = birthDate;
        this.email = email;
        this.profileEmail = profileEmail;
        this.address = address;
        this.phonePrefix = phonePrefix;
        this.phoneNumber = phoneNumber;
        this.password = password;
        this.repeatPassword = repeatPassword;
        this.pin = pin;
        this.repeatPin = repeatPin;
        this.profilePhoto = profilePhoto;
        this.cedulaPhoto = cedulaPhoto;
        this.passportPhoto = passportPhoto;
        this.keyValid = keyValid;
    }
}